<app-flex
  gap="16px"
  margin="16px"
>
  <div class="epp-calculator-input-card">
    @if (planToggleVisible) {
      <div class="card-title">Select plan</div>
      <app-early-pay-calculator-plan-toggle (updateSubscriptionFee)="updateSubscriptionFee($event)" />
      <mat-divider class="epp-calculator-divider" />
    }

    <div class="card-title">Enter invoice amount</div>
    <mat-form-field
      appearance="outline"
      class="invoice-field"
    >
      <input
        matInput
        currencyMask
        class="invoice-input"
        type="text"
        [formControl]="invoiceAmountControl"
        [options]="{ prefix: '$ ', align: 'center' }"
      />
      @if (invoiceAmountControl.hasError('min')) {
        <mat-error>Amount should be more than or equal $1</mat-error>
      }
      @if (invoiceAmountControl.hasError('max')) {
        <mat-error>Amount should be less than or equal $500000000</mat-error>
      }
    </mat-form-field>

    <mat-divider class="epp-calculator-divider" />

    <div class="card-title">Pick net payment terms (days)</div>
    <app-early-pay-calculator-days-selector (changeDays)="updateDaysAmount($event)" />
  </div>

  <div class="epp-calculator-output-card">
    <div class="amount-header-container">Invoice Amount</div>
    <div class="amount-container">
      {{ invoiceAmountControl.value | currency }}
    </div>
    <div class="fee-container">Advanced Payment 75%</div>

    <div class="amount-header-container">Within 48 hours</div>
    <div class="amount-container">
      {{ advancedPaymentAmount | currency }}
    </div>
    <div class="fee-container">(Includes fee of {{ feeAmount | currency }})</div>

    <div class="amount-header-container">In {{ days$.value }} days</div>
    <div class="amount-container amount-container-with-margin">
      {{ finalPaymentAmount | currency }}
    </div>
  </div>
</app-flex>
